import React, { Component } from "react";
import { Dialog, InputGroup, Button, Callout, Switch, Icon } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../../components/LoadingIndicator";
import ReactPasswordStrength from 'react-password-strength';


export default class RegisterDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      register_form: {
        user_name: "",
        first_name: "",
        last_name: "",
        password: "",
        accepted_terms: false
      },
      validation_errors: {}
    };
    this.handleOnClose = this.handleOnClose.bind(this);
    this.updateFields = this.updateFields.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleLoginClick = this.handleLoginClick.bind(this);
  }

  updateFields(event) {
    if ("password" in event) {
      this.setState({
        register_form: {
          ...this.state.register_form,
          password: event.password
        }
      });
    } else {
      this.setState({
        register_form: {
          ...this.state.register_form,
          [event.target.id]: event.target.value
        }
      });
    }
  }

  termsAndConditionsChanged = (event) => {
    this.setState({
      register_form: {
        ...this.state.register_form,
        accepted_terms: event.target.checked
      }
    });
  }

  submitForm(e) {
    e.preventDefault();
    const validationErrors = validate(
      this.state.register_form,
      this.props.validators
    );
    this.setState({
      validation_errors: validationErrors ? validationErrors : {}
    });

    if (!validationErrors) {
      this.props.onRegister(
        this.state.register_form.user_name,
        this.state.register_form.password,
        this.state.register_form.first_name,
        this.state.register_form.last_name
      );
    }
  }
  handleOnClose = _ => {
    this.props.onClose();
  };
  handleLoginClick = e => {
    e.preventDefault();
    this.props.goToLogin();
  };
  render() {
    return (
      <Dialog
        onClose={this.handleOnClose}
        title={I18n.t("sign_up.title")}
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        enforceFocus={true}
        isOpen={this.props.isOpen}
        usePortal={true}>
        <div className="dialog-wrapper">
          <form onSubmit={this.submitForm} className="login-form">
            <div
              className={
                this.state.validation_errors.user_name
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.user_name && (
                <label htmlFor="user_name">
                  <Translate
                    value={this.state.validation_errors.user_name[0]}
                  />
                </label>
              )}
              <InputGroup
                leftIcon="envelope"
                type="email"
                placeholder={I18n.t("sign_up.placeholders.email_address")}
                fill={true}
                id="user_name"
                disabled={this.props.isLoading}
                intent={this.state.validation_errors.user_name ? "danger" : ""}
                onChange={this.updateFields}
              />
            </div>
            <div
              className={
                this.state.validation_errors.first_name
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.first_name && (
                <label htmlFor="first_name">
                  <Translate
                    value={this.state.validation_errors.first_name[0]}
                  />
                </label>
              )}
              <InputGroup
                leftIcon="person"
                type="text"
                placeholder={I18n.t("sign_up.placeholders.first_name")}
                fill={true}
                id="first_name"
                disabled={this.props.isLoading}
                intent={this.state.validation_errors.first_name ? "danger" : ""}
                onChange={this.updateFields}
              />
            </div>
            <div
              className={
                this.state.validation_errors.last_name
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.last_name && (
                <label htmlFor="last_name">
                  <Translate
                    value={this.state.validation_errors.last_name[0]}
                  />
                </label>
              )}
              <InputGroup
                leftIcon="person"
                type="text"
                placeholder={I18n.t("sign_up.placeholders.last_name")}
                fill={true}
                id="last_name"
                disabled={this.props.isLoading}
                intent={this.state.validation_errors.last_name ? "danger" : ""}
                onChange={this.updateFields}
              />
            </div>
            <div
              className={
                this.state.validation_errors.password
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.password && (
                <label htmlFor="password">
                  <Translate value={this.state.validation_errors.password[0]} />
                </label>
              )}
              <div className="react-pass-strength">
                <ReactPasswordStrength
                  minLength={5}
                  minScore={2}
                  scoreWords={[I18n.t('password_score.weak'), I18n.t('password_score.okay'), I18n.t('password_score.good'), I18n.t('password_score.strong'), I18n.t('password_score.stronger')]}
                  tooShortWord={I18n.t('password_score.too_short')}
                  changeCallback={this.updateFields}
                  inputProps={{ name: "password", autoComplete: "off", className: "bp5-input", placeholder: I18n.t("sign_up.placeholders.password") }}
                />
                <Icon icon="lock" className="pass-strength-icon" />
              </div>
            </div>

            <div
              className={
                this.state.validation_errors.accepted_terms
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.accepted_terms && (
                <label htmlFor="password">
                  <Translate value={this.state.validation_errors.accepted_terms[0]} />
                </label>
              )}
              <Switch
                checked={this.state.register_form.accepted_terms}
                label={
                  <span>
                    <Translate value="sign_up.read_and_accept" />{" "}
                    <a target="_blank" href="/privacy-policy"><Translate value="menu.privacy_policy" /></a> &amp;{" "}
                    <a target="_blank" href="/terms-of-use"><Translate value="menu.terms_of_use" /></a>
                  </span>
                }
                onChange={this.termsAndConditionsChanged}
              />
            </div>
            {this.props.isLoading && <LoadingIndicator />}
            {!this.props.isLoading && (
              <Button
                disabled={this.props.isLoading}
                className="register-button"
                intent="primary"
                fill={true}
                type="submit">
                <Translate value="sign_up.register" />
              </Button>
            )}
            <Callout className="switch-form-type">
              <Translate value="sign_up.have_account" />{" "}
              <a href=" " onClick={this.handleLoginClick}>
                <Translate value="sign_up.login_here" />
              </a>
            </Callout>
          </form>
        </div>
      </Dialog>
    );
  }
}
